export const getActiveNotificationType = (notificationState) => {
    const activeNotification = Object.keys(notificationState)
        .find((notificationType) => notificationState[notificationType].display === true);

    if (activeNotification) {
        return activeNotification;
    }

    return 'error';
}
